var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDiscount = function SvgDiscount(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.48659 13.1333C5.03325 12.5466 5.86659 12.5933 6.34659 13.2333L7.01992 14.1333C7.55992 14.8466 8.43325 14.8466 8.97325 14.1333L9.64659 13.2333C10.1266 12.5933 10.9599 12.5466 11.5066 13.1333C12.6933 14.3999 13.6599 13.9799 13.6599 12.2066V4.69325C13.6666 2.00659 13.0399 1.33325 10.5199 1.33325H5.47992C2.95992 1.33325 2.33325 2.00659 2.33325 4.69325V12.1999C2.33325 13.9799 3.30659 14.3933 4.48659 13.1333Z",
    stroke: "#FF5F5A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 8.66675L10 4.66675",
    stroke: "#FF5F5A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99642 8.66659H10.0024",
    stroke: "#FF5F5A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99642 5.00008H6.00241",
    stroke: "#FF5F5A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgDiscount;